<template>
  <el-dialog
    title="发送消息"
    :visible="show"
    @close="closeDialog"
    :close-on-click-modal="false"
  >
    <el-card
      class="box-card"
      shadow="never"
      style="margin-bottom: 10px"
      v-for="(item, index) in templateArr"
      :key="index"
    >
      <div slot="header" class="clearfix">
        <span style="font-weight: bold">模板{{ index + 1 }}</span>
        <el-button type="primary" size="mini" @click="handleFill(item)"
          >填入</el-button
        >
      </div>
      <div class="cardContent">
        <div class="messageItem">
          <div class="messageName">消息标题：</div>
          <div class="messageInfo">{{ item.title }}</div>
        </div>
        <div class="messageItem">
          <div class="messageName">消息内容：</div>
          <div class="messageInfo">
            {{ item.content }}
          </div>
        </div>
      </div>
    </el-card>
    <el-card class="box-card" shadow="never">
      <div slot="header" class="clearfix">
        <span style="font-weight: bold">自定义消息</span>
      </div>
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-width="90px"
        style="margin-top: 20px"
      >
        <el-form-item label="消息标题" prop="title">
          <el-input
            v-model="form.title"
            placeholder="请输入消息标题"
            maxlength="15"
          ></el-input>
        </el-form-item>
        <el-form-item label="消息内容" prop="content">
          <el-input
            v-model="form.content"
            placeholder="请输入消息内容"
            maxlength="180"
            type="textarea"
            :autosize="{ minRows: 2 }"
          ></el-input>
        </el-form-item>
      </el-form>
    </el-card>

    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="submit"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: {
    show: Boolean,
    id: Array,
  },
  data() {
    return {
      dialogShow: this.show,
      form: {
        title: '',
        content: '',
      },
      rules: {
        title: [
          { required: true, message: '请输入消息标题', trigger: 'blur' },
          { min: 5, max: 15, message: '请输入5到15个字符', trigger: 'blur' },
        ],
        content: [
          { required: true, message: '请输入消息内容', trigger: 'blur' },
          {
            min: 10,
            max: 180,
            message: '请输入10到180个字符',
            trigger: 'blur',
          },
        ],
      },
      templateArr: [
        {
          title: '代付异常通知',
          content:
            '代付异常，请暂停使用代付，等待通知开启',
        },
        {
          title: '代收异常通知',
          content:
            '代收异常，请暂停使用代付，等待通知开启',
        },
        {
          title: '代付维护通知',
          content:
            '代付业务维护，预计20分钟完成，请关注运行情况，有问题及时联系',
        },
      ],
      submitLoading: false,
    }
  },
  methods: {
    closeDialog() {
      this.submitLoading = false
      this.dialogShow = false
      this.$refs['form'].resetFields() //关闭的时候重置表单
      this.$emit('update:show', false)
    },
    handleFill(item) {
      this.form = Object.assign({}, item)
      this.$refs['form'].resetFields()
    },
    submit() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.submitLoading = true

          var ids = '';
          this.id.forEach((v, i) => {
            ids = ids + v + ",";
          });

          const params = {
            title: this.form.title,
            content: this.form.content,
            groups: ids,
          }
          this.axios
            .post('/notice/sendTgMsg', params)
            .then(res => {
              if (res.code === 200) {
                this.$notify({
                  title: '提示',
                  message: res.msg,
                  type: 'success',
                })
                this.closeDialog()
              } else {
                this.$notify.error({
                  title: '提示',
                  message: res.msg,
                })
                this.submitLoading = false
              }
            })
            .catch(err => {
              this.submitLoading = false
            })
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-card__header {
  padding: 6px 10px;
  .clearfix {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 28px;
  }
}
.messageItem {
  display: flex;
  line-height: 22px;
  .messageInfo {
    flex: 1;
  }
}
::v-deep .el-card__body {
  padding: 2px 10px;
}
::v-deep .el-dialog__body {
  padding: 10px 20px;
}
</style>